export const RENTER_ADD_REVIEW = "RENTER_ADD_REVIEW"
export const RENTER_ADD_REVIEW_SUCCESSFUL = "RENTER_ADD_REVIEW_SUCCESSFUL"
export const RENTER_ADD_REVIEW_FAILED = "RENTER_ADD_REVIEW_FAILED"
export const RENTER_ADD_REVIEW_RESET = "RENTER_ADD_REVIEW_RESET"

